import styled from '@emotion/styled';
import { Column, Row } from '@landsbankinn/ui';
import React from 'react';
import type { OrderGiftCardInput } from '../../../../__generated__/globalTypes';
import { Amount } from './form/inputs/Amount';
import { Email } from './form/inputs/Email';
import { Kennitala } from './form/inputs/Kennitala';
import { Location } from './form/inputs/Location';
import { Name } from './form/inputs/Name';
import { NumberOfCards } from './form/inputs/NumberOfCards';
import { PhoneNumber } from './form/inputs/PhoneNumber';

interface IProps {
  kennitalaNotFound: boolean;
  setKennitalaNotFound: React.Dispatch<React.SetStateAction<boolean>>;
  deliveryPlaceOptions?: {
    label: string;
    options: { label: string; value: string }[];
  }[];

  formData: OrderGiftCardInput;
  setOrderGiftCardInput: React.Dispatch<
    React.SetStateAction<OrderGiftCardInput>
  >;
}

const StyledColumn = styled(Column)`
  margin-bottom: ${(props) => props.theme.baseline * 8}px;
`;

export function PersonForm({
  deliveryPlaceOptions,
  formData,
  kennitalaNotFound,
  setKennitalaNotFound,
  setOrderGiftCardInput,
}: IProps) {
  const {
    numberOfGiftCards,
    amountOnEachCard,
    name,
    kennitala,
    phoneNumber,
    email,
    servicePointId,
  } = formData;

  return (
    <>
      <Row>
        <StyledColumn
          sm={{ width: 12 / 12 }}
          md={{ width: 5 / 12, offset: 1 / 12 }}
        >
          <NumberOfCards
            numberOfCards={numberOfGiftCards}
            setNumberOfCards={(number) =>
              setOrderGiftCardInput({ ...formData, numberOfGiftCards: number })
            }
          />
        </StyledColumn>
        <StyledColumn sm={{ width: 12 / 12 }} md={{ width: 5 / 12 }}>
          <Amount
            amount={amountOnEachCard}
            setAmount={(amount) =>
              setOrderGiftCardInput({ ...formData, amountOnEachCard: amount })
            }
          />
        </StyledColumn>

        <StyledColumn
          sm={{ width: 12 / 12 }}
          md={{ width: 5 / 12, offset: 1 / 12 }}
        >
          <Name
            name={name}
            label="Nafn kaupanda"
            setName={(name) => setOrderGiftCardInput({ ...formData, name })}
          />
        </StyledColumn>
        <StyledColumn sm={{ width: 12 / 12 }} md={{ width: 2.5 / 12 }}>
          <Kennitala
            kennitalaNotFound={kennitalaNotFound}
            kennitala={kennitala}
            setKennitala={(kennitala) => {
              setKennitalaNotFound(false);
              setOrderGiftCardInput({
                ...formData,
                kennitala,
              });
            }}
          />
        </StyledColumn>
        <StyledColumn sm={{ width: 12 / 12 }} md={{ width: 2.5 / 12 }}>
          <PhoneNumber
            phoneNumber={phoneNumber}
            setPhoneNumber={(phoneNumber) =>
              setOrderGiftCardInput({ ...formData, phoneNumber })
            }
          />
        </StyledColumn>
        <StyledColumn
          sm={{ width: 12 / 12 }}
          md={{ width: 5 / 12, offset: 1 / 12 }}
        >
          <Email
            email={email}
            setEmail={(email) => setOrderGiftCardInput({ ...formData, email })}
          />
        </StyledColumn>
        <StyledColumn sm={{ width: 12 / 12 }} md={{ width: 5 / 12 }}>
          {deliveryPlaceOptions && (
            <Location
              deliveryPlaceOptions={deliveryPlaceOptions}
              selectedId={servicePointId ? servicePointId : undefined}
              setSelcetedId={(id) => {
                setOrderGiftCardInput({ ...formData, servicePointId: id });
              }}
            />
          )}
        </StyledColumn>
      </Row>
    </>
  );
}
